/* eslint-disable react/prop-types */
/* eslint-disable indent */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FiFilter, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { HiOutlineRefresh } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBundlesToCompare,
  selectRetrofitConfiguration,
  selectFiltersInit,
  selectFiltersWrapperOpened,
  selectPossibleFiltersValues,
  setFiltersWrapperOpened,
  showSnackbar,
  setAxisFilters,
  addNewAxisForCartesian,
  setMotorSynchronizedFilters,
  setDriveSynchronizedFilters,
  setGearboxSynchronizedFilters,
  setSavedMotorDependenciesPayload,
  setSavedDriveDependenciesPayload,
  setSavedGearboxDependenciesPayload,
  saveApplicationDataDependencies,
  deleteAllAxisForCartesian,
  selectFetchedBundles,
  setApplicationDataFilter
} from "../../../Retrofit/store/slices/retrofit";
import { logEvent, syncFiltersDependencies } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import DriveFilters from "./Filters/DriveFilters";
import GearboxFilters from "./Filters/GearboxFilters";
import MotorFilters from "./Filters/MotorFilters";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import { selectConfigurationType, selectEventsData } from "../../../Common/store/slices/common";
import { selectIntegratedDrivesConfiguration } from "../../../IntegratedDrives/store/slices/integrated_drives";
import { useQuery, useQueryClient } from "react-query";
import { selectSelectedAxis } from "../../../Cartesian/store/slices/cartesian";
import { selectCartesianConfiguration } from "../../../Cartesian/store/slices/cartesian";
import { formatConnectorType, formatMotorEncoder, formatNbPhases, formatShaftEnd } from "../../utils/func.util";

const FiltersWrapper = ({ filters, motorTab, driveTab, gearboxTab, axisId, refetchBundles }) => {
  const dispatch = useDispatch();
  const isMobile = useCheckMobileScreen();
  const eventsData = useSelector(selectEventsData);
  const retrofitConfiguration = useSelector(selectRetrofitConfiguration);
  const cartesianConfiguration = useSelector(selectCartesianConfiguration);
  const integratedDrivesConfiguration = useSelector(selectIntegratedDrivesConfiguration);
  const isIntegratedDrivesConfiguration = integratedDrivesConfiguration !== null;
  const configuration = integratedDrivesConfiguration || retrofitConfiguration;
  const configurationType = useSelector(selectConfigurationType);
  const filtersInit = useSelector(selectFiltersInit);
  const possibleMotorFiltersValues = useSelector(selectPossibleFiltersValues)?.motor || {};
  const possibleGearboxFiltersValues = useSelector(selectPossibleFiltersValues)?.gearbox;
  const filtersWrapperOpened = useSelector(selectFiltersWrapperOpened);
  const [isClearing, setIsClearing] = useState(false);
  const selectedAxis = useSelector(selectSelectedAxis);
  const fetchedBundles = useSelector(selectFetchedBundles);

  const handleClickTab = (tabName) => {
    dispatch(setFiltersWrapperOpened(filtersWrapperOpened === tabName ? null : tabName));
  };

  const [withGearbox, setWithGearbox] = useState(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled);
  const [filtersAppliedByProductType, setFiltersAppliedByProductType] = useState({
    Drive: 0,
    Gearbox: 0,
    Motor: 0
  });
  const [mandatoryFiltersFilled, setMandatoryFiltersFilled] = useState({
    Drive: false,
    Gearbox: false,
    Motor: false
  });

  const getMinMotorFlangeSize = () => {
    return possibleMotorFiltersValues?.flangeSize?.min;
  };

  const getMaxMotorFlangeSize = () => {
    return possibleMotorFiltersValues?.flangeSize?.max;
  };

  const [payload, setPayload] = useState({
    locale: window.msizerConfiguration?.locale || "en-WW",
    search: {
      applicationDataFilter: {
        supplyVoltage: filters?.driveFilter?.supplyVoltage?.length > 0 ? filters?.driveFilter.supplyVoltage : undefined,
        nominalTorqueOfMotor: filters?.motorFilter?.nominalTorque,
        nominalSpeedOfMotor: filters?.motorFilter?.nominalSpeed,
        nominalTorque: filters?.applicationDataFilter?.nominalTorque
          ? {
              min: parseFloat(filters?.applicationDataFilter?.nominalTorque)
              /*
              max:
                parseFloat(filters?.applicationDataFilter?.nominalTorque) *
                getNominalToqueMultiplicator(configurationType)
              */
            }
          : undefined,
        // nominalSpeed is named nominalSpeed but actually it's considered as a minimum
        nominalSpeed: filters?.applicationDataFilter?.nominalSpeed
          ? {
              min: Number(filters?.applicationDataFilter?.nominalSpeed)
            }
          : undefined,
        withGearbox: filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled,
        length: filters?.applicationDataFilter?.maxLength
          ? { max: Number(filters?.applicationDataFilter?.maxLength) }
          : undefined,
        withBrake: filters?.motorFilter.holdingBrake.length !== 1 ? undefined : filters?.motorFilter.holdingBrake[0]
      },
      motorFilter: {
        type: filters?.motorFilter.motorType?.length > 0 ? filters?.motorFilter.motorType : undefined,
        nominalTorqueOfMotor: filters?.motorFilter.nominalTorque,
        encoder:
          formatMotorEncoder(filters?.motorFilter.motorEncoder)?.length > 0
            ? formatMotorEncoder(filters?.motorFilter.motorEncoder)
            : undefined,
        connector:
          formatConnectorType(filters?.motorFilter.connectorType)?.length > 0
            ? formatConnectorType(filters?.motorFilter.connectorType)
            : undefined,
        flangeSize: filters?.motorFilter.flangeSize,
        withBrake: filters?.motorFilter.holdingBrake.length !== 1 ? undefined : filters?.motorFilter.holdingBrake[0],
        length: filters?.motorFilter.length,
        ipProtections:
          filters?.motorFilter.ipDegreeOfProtection.length > 0 ? filters?.motorFilter.ipDegreeOfProtection : undefined,
        shaftEnd:
          formatShaftEnd(filters?.motorFilter.shaftEnd)?.length > 0
            ? formatShaftEnd(filters?.motorFilter.shaftEnd)
            : undefined,
        peakStallTorque: filters?.motorFilter.peakStallTorque,
        continuousStallTorque: filters?.motorFilter.continuousStallTorque
      },
      driveFilter: {
        type: filters?.driveFilter.driveType?.length > 0 ? filters?.driveFilter.driveType : undefined,
        outputCurrents:
          filters?.driveFilter?.outputCurrent?.length > 0 ? filters?.driveFilter.outputCurrent : undefined,
        communicationInterfaces:
          filters?.driveFilter.driveInterface?.length > 0 ? filters?.driveFilter.driveInterface : undefined,
        nominalPower: filters?.driveFilter.nominalPower?.length > 0 ? filters?.driveFilter.nominalPower : undefined,
        switchingFreq: filters?.driveFilter.switchingFreq?.length > 0 ? filters?.driveFilter.switchingFreq : undefined,
        format: filters?.driveFilter.format?.length > 0 ? filters?.driveFilter.format : undefined,
        nbPhases:
          formatNbPhases(filters?.driveFilter.nbPhases)?.length > 0
            ? formatNbPhases(filters?.driveFilter.nbPhases)
            : undefined,
        outputVoltages: filters?.driveFilter?.driveVoltages.length > 0 ? filters?.driveFilter.driveVoltages : undefined
      },
      gearboxFilter: {
        manufacturer: undefined,
        type: filters?.gearboxFilter.gearboxType?.length > 0 ? filters?.gearboxFilter.gearboxType : undefined,
        precision: undefined,
        reductionRatio: filters?.gearboxFilter.ratio.length > 0 ? filters?.gearboxFilter.ratio : undefined,
        specification: undefined,
        efficiency: filters?.gearboxFilter.efficiency?.length > 0 ? filters?.gearboxFilter.efficiency : undefined,
        productOrComponentType:
          filters?.gearboxFilter.productOrComponentType?.length > 0
            ? filters?.gearboxFilter.productOrComponentType
            : undefined,
        torsionalBacklash: filters?.gearboxFilter?.torsionalBacklash,
        inputDiameter:
          filters?.gearboxFilter.inputDiameter?.length > 0 ? filters?.gearboxFilter.inputDiameter : undefined,
        externalDiameter:
          filters?.gearboxFilter.externalDiameter?.length > 0 ? filters?.gearboxFilter.externalDiameter : undefined
      }
    },
    selectedAxis: selectedAxis?.axis?.axisGCR,
    selectedAxisInertia: selectedAxis?.calculations?.totalAxisInertiaPreCalculations.preCalcTranslationalInertia
  });

  useEffect(() => {
    // Check if there already are fetched bundles
    if (!fetchedBundles || fetchedBundles?.length === 0) {
      const checkDriveFilters = () => {
        return (
          filters?.driveFilter?.driveInterface?.length > 0 &&
          filters?.driveFilter?.driveInterface?.[0] !== "" &&
          filters?.driveFilter?.nbPhases?.length > 0 &&
          filters?.driveFilter?.nbPhases?.[0] !== "" &&
          filters?.driveFilter?.driveVoltages?.length > 0 &&
          filters?.driveFilter?.driveVoltages?.[0] !== ""
        );
      };

      // check motor filters function
      const checkMotorFilters = () => {
        return (
          filters?.motorFilter?.ipDegreeOfProtection?.length > 0 &&
          filters?.motorFilter?.holdingBrake?.length > 0 &&
          (!(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled) ||
            filters?.gearboxFilter?.productOrComponentType?.length > 0)
        );
      };

      // check gearbox filters function
      const checkGearboxFilters = () => {
        return (
          !(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled) ||
          filters?.gearboxFilter?.productOrComponentType?.length > 0
        );
      };

      // Recalculate dependency filters
      queryClient.setQueryData("SYNC_FILTERS", payload);
      execSyncFilters().then(() => {
        // if filters?.driveFilter object is not empty then check if all mandatory filters are filled
        const driveFiltersApplicable = filters?.driveFilter !== undefined && filters?.driveFilter !== null;

        // if filters?.motorFilter object is not empty then check if all mandatory filters are filled
        const motorFiltersApplicable = filters?.motorFilter !== undefined && filters?.motorFilter !== null;

        // if filters?.gearboxFilter object is not empty then check if all mandatory filters are filled
        const gearboxFiltersApplicable = filters?.gearboxFilter !== undefined && filters?.gearboxFilter !== null;

        // if filters are applicable and all mandatory filters are filled then refetch bundles
        if (
          filters &&
          (!driveFiltersApplicable || checkDriveFilters()) &&
          (!motorFiltersApplicable || checkMotorFilters()) &&
          (!gearboxFiltersApplicable || checkGearboxFilters())
        ) {
          refetchBundles();
        }
      });
    }
  }, []);

  useEffect(() => {
    setWithGearbox(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled);
  }, [filters]);

  useEffect(() => {
    // Set filtersAppliedByProductType
    const filtersAppliedByProductTypeCopy = {
      ...filtersAppliedByProductType
    };

    // get number of filters applied by drive (number of filters that have length > 0)
    filtersAppliedByProductTypeCopy.Drive = Object.keys(filters?.driveFilter || {})?.filter(
      (f) =>
        !["nbPhases", "driveVoltagesSplitted"].includes(f) &&
        filters?.driveFilter?.[f]?.length > 0 &&
        filters?.driveFilter?.[f]?.[0] !== ""
    )?.length;

    // get number of filters applied by gearbox (number of filters that have length > 0)
    filtersAppliedByProductTypeCopy.Gearbox = Object.keys(filters?.gearboxFilter || {})?.filter(
      (f) => filters?.gearboxFilter?.[f]?.length > 0
    )?.length;

    // get number of filters applied by Motor (number of filters that have length > 0 and...)
    filtersAppliedByProductTypeCopy.Motor = Object.keys(filters?.motorFilter || {})?.filter(
      (f) =>
        filters?.motorFilter?.[f]?.length > 0 ||
        filters?.motorFilter?.[f]?.min > possibleMotorFiltersValues[f]?.min ||
        filters?.motorFilter?.[f]?.max < possibleMotorFiltersValues[f]?.max
    )?.length;

    setFiltersAppliedByProductType(filtersAppliedByProductTypeCopy);
  }, [filters]);

  useEffect(() => {
    setMandatoryFiltersFilled({
      Drive: filters?.driveFilter?.driveInterface?.length > 0 && filters?.driveFilter?.driveInterface?.[0] !== "",
      Motor: filters?.motorFilter?.ipDegreeOfProtection?.length > 0 && filters?.motorFilter?.holdingBrake?.length > 0,
      Gearbox: !withGearbox || filters?.gearboxFilter?.productOrComponentType?.length > 0
    });
  }, [filters]);

  const queryClient = useQueryClient();

  const {
    refetch: execSyncFilters,
    isFetching: isFetchingSyncFilters,
    isLoading: isLoadingSyncFilters
  } = useQuery(
    "SYNC_FILTERS",
    async () => {
      try {
        const receivedPayload = queryClient.getQueryData("SYNC_FILTERS");
        // console.log("NEW PAYLOAD", receivedPayload);

        const axisFromConfiguration = configuration?.configData.axes.find((a) => a.id === axisId);
        const previousPayload = axisFromConfiguration?.axisState?.savedApplicationDataPayload;
        // console.log("PREVIOUS PAYLOAD", previousPayload);

        // check if the new payload is different from the previous one (to avoid useless calls)
        if (JSON.stringify(receivedPayload) !== JSON.stringify(previousPayload)) {
          // sync application data filters
          let newPayload = { ...receivedPayload };
          let newApplicationDataFilters = await syncFiltersDependencies(configurationType, newPayload);
          newApplicationDataFilters = {
            ...newApplicationDataFilters,
            motor: {
              ...newApplicationDataFilters?.motor
            }
          };
          dispatch(
            saveApplicationDataDependencies({
              axisId,
              dependencies: newApplicationDataFilters?.applicationData,
              appDataPayload: receivedPayload
            })
          );

          dispatch(setMotorSynchronizedFilters(JSON.parse(JSON.stringify(newApplicationDataFilters?.motor))));
          dispatch(setDriveSynchronizedFilters(JSON.parse(JSON.stringify(newApplicationDataFilters?.drive))));
          dispatch(setGearboxSynchronizedFilters(JSON.parse(JSON.stringify(newApplicationDataFilters?.gearbox))));
          dispatch(setSavedMotorDependenciesPayload(receivedPayload.motor));
          dispatch(setSavedDriveDependenciesPayload(receivedPayload.drive));
          dispatch(setSavedGearboxDependenciesPayload(receivedPayload.gearbox));
        } else {
          console.log("SAME PAYLOAD : REQUEST NOT SEND");
        }
      } catch (error) {
        console.log("error", error);
        dispatch(showSnackbar({ id: "ERROR_FILTERS" }));
        logEvent(eventsData.locale, eventsData.types.errorFilters, eventsData.tags.none, configuration?.configId);
      }
    },
    {
      enabled: false
    }
  );

  const handleClearFilters = () => {
    setIsClearing(true);
    setTimeout(() => {
      setIsClearing(false);
    }, 500);
    const newFilters = {
      ...configuration.configData.axes.find((a) => a.id === axisId)?.configFilters,
      motorFilter: filtersInit.motorFilter || {},
      // driveFilters is filtersInit.driveFilter + application  settings filters
      driveFilter: {
        ...(filtersInit.driveFilter || {}),
        ...(configuration?.configData?.applicationSettings || {})
      },
      gearboxFilter: filtersInit.gearboxFilter || {}
    };
    if (cartesianConfiguration) {
      // console.log("Clearing filters for cartesian configuration", axisId);
      dispatch(deleteAllAxisForCartesian());
      dispatch(addNewAxisForCartesian(cartesianConfiguration.configData?.axisSelection?.selectedAxis));
      dispatch(setApplicationDataFilter({ axisId, applicationDataFilter: newFilters.applicationDataFilter }));
    } else {
      // console.log("Clearing filters for retrofit configuration");
      dispatch(setAxisFilters({ axisId, filters: newFilters }));
    }
    dispatch(clearBundlesToCompare());
    // change the following part to optimize it
    // (the goal is to re-render to filter tab which is already opened)
    const oldfiltersWrapperOpened = filtersWrapperOpened;
    dispatch(setFiltersWrapperOpened(null));
    setTimeout(() => {
      dispatch(setFiltersWrapperOpened(oldfiltersWrapperOpened));
    }, 1);
    dispatch(showSnackbar({ id: "RESET_FILTERS" }));
    logEvent(
      eventsData.locale,
      eventsData.types.resetFilters,
      eventsData.tags.bundleSelection,
      configuration?.configId
    );
  };

  const getFiltersAppliedText = (productType) => {
    const filtersApplied = filtersAppliedByProductType[productType];

    return filtersApplied === 0 ? (
      t("msizer.ui.filters.no_filters_applied")
    ) : (
      <>
        {filtersApplied}{" "}
        {filtersApplied === 1 ? t("msizer.ui.filters.filter_applied") : t("msizer.ui.filters.filters_applied")}
      </>
    );
  };

  const handleMotorFiltersUpdate = (newFilters) => {
    // console.log("SYNC MOTOR FILTERS", newFilters);
    const payloadToSend = {
      ...payload,
      search: {
        ...payload.search,
        applicationDataFilter: {
          ...payload.search.applicationDataFilter,
          nominalTorqueOfMotor: possibleMotorFiltersValues?.nominalTorque, // range
          nominalSpeedOfMotor: possibleMotorFiltersValues?.nominalSpeed,
          withGearbox: newFilters?.withGearbox || false,
          withBrake: newFilters?.holdingBrake.length !== 1 ? undefined : newFilters?.holdingBrake[0]
        },
        motorFilter: {
          ...payload.search.motorFilter,
          type: newFilters?.motorType,
          nominalTorqueOfMotor: possibleMotorFiltersValues?.nominalTorque,
          encoder: formatMotorEncoder(newFilters?.motorEncoder),
          connector: formatConnectorType(newFilters?.connectorType),
          flangeSize: { min: getMinMotorFlangeSize(), max: getMaxMotorFlangeSize() },
          withBrake: newFilters?.holdingBrake.length !== 1 ? undefined : newFilters?.holdingBrake[0],
          length: possibleMotorFiltersValues?.motorLength,
          ipProtections: newFilters?.ipDegreeOfProtection,
          shaftEnd: formatShaftEnd(newFilters?.shaftEnd)
        }
      }
    };
    setPayload(payloadToSend);
    queryClient.setQueryData("SYNC_FILTERS", payloadToSend);
    execSyncFilters();
  };

  const handleDriveFiltersUpdate = (newFilters) => {
    // console.log("SYNC DRIVE FILTERS", newFilters);
    const payloadToSend = {
      ...payload,
      search: {
        ...payload.search,
        driveFilter: {
          ...payload.search.driveFilter,
          type: newFilters?.driveType || undefined,
          outputCurrents: newFilters?.outputCurrent?.length > 0 ? newFilters?.outputCurrent : undefined,
          communicationInterfaces: newFilters?.driveInterface.length > 0 ? newFilters?.driveInterface : undefined,
          nominalPower: newFilters?.nominalPower || undefined,
          switchingFreq: newFilters?.switchingFreq || undefined,
          format: newFilters?.format || undefined,
          nbPhases: formatNbPhases(newFilters?.nbPhases).length > 0 ? formatNbPhases(newFilters?.nbPhases) : undefined,
          outputVoltages: newFilters?.driveVoltages.length > 0 ? newFilters?.driveVoltages : undefined
        }
      }
    };
    setPayload(payloadToSend);
    queryClient.setQueryData("SYNC_FILTERS", payloadToSend);
    execSyncFilters();
  };

  const handleGearboxFiltersUpdate = (newFilters) => {
    // console.log("SYNC GEARBOX FILTERS", newFilters);
    const payloadToSend = {
      ...payload,
      search: {
        ...payload.search,
        applicationDataFilter: {
          ...payload.search.applicationDataFilter,
          withGearbox: newFilters?.enabled || false
        },
        gearboxFilter: {
          ...payload.search.gearboxFilter,
          reductionRatio: newFilters?.ratio && newFilters?.ratio.length > 0 ? newFilters?.ratio : undefined,
          productOrComponentType:
            newFilters?.productOrComponentType && newFilters?.productOrComponentType.length > 0
              ? newFilters?.productOrComponentType
              : undefined,
          torsionalBacklash: newFilters?.torsionalBacklash,
          externalDiameter:
            newFilters?.externalDiameter && newFilters?.externalDiameter.length > 0
              ? newFilters?.externalDiameter
              : undefined
        }
      }
    };
    setPayload(payloadToSend);
    queryClient.setQueryData("SYNC_FILTERS", payloadToSend);
    execSyncFilters();
  };

  return (
    <div className="FiltersWrapper space-y-2 filtersWrapper">
      {/* <div className="app-overlay h-screen w-screen absolute top-0 left-0
       bg-gray-100 opacity-50 brightness-50 z-10" /> */}

      <div className="flex select-none">
        <div className="flex-1 flex items-center text-sm space-x-2 text-gray-500">
          <FiFilter />
          <span className="">{isMobile ? t("msizer.ui.filters.title.short") : t("msizer.ui.filters.title")}</span>
        </div>
        {!integratedDrivesConfiguration && (
          <div className="flex-1 flex items-center justify-end text-sm text-secondary">
            <div
              onClick={() => {
                handleClearFilters();
              }}
              className="flex items-center space-x-1 cursor-pointer"
            >
              <HiOutlineRefresh className={isClearing && "animate-spin"} />
              <span>{t("msizer.ui.filters.reset_filters")}</span>
            </div>
          </div>
        )}
      </div>

      <div>
        <div className="flex md:space-x-4 flex-col md:flex-row gap-2 md:gap-0">
          {driveTab && (
            <div
              id="select-tab-filters-drive"
              onClick={() => handleClickTab("DRIVE")}
              className={`flex-1 max-w-[33%] flex drop-shadow border-[1px] border-solid border-gray-100 border-l-4 border-l-primary px-2 py-1 select-none cursor-pointer ${
                filtersWrapperOpened && filtersWrapperOpened !== "DRIVE"
                  ? "bg-gray-200 text-gray-500"
                  : "bg-white border-b-0"
              } ${isMobile && filtersWrapperOpened && filtersWrapperOpened !== "DRIVE" && "hidden"}`}
            >
              <div className="flex-1 flex flex-col">
                <span className="text-xs font-bold uppercase text-left">
                  {t("msizer.ui.drive")}
                  {/* <span className="text-red-500 ml-1">*</span> */}
                </span>
                <div className="flex text-xxs space-x-1">
                  <span>{getFiltersAppliedText("Drive")} </span>
                  {!mandatoryFiltersFilled.Drive && (
                    <span className="text-red-500">({t("msizer.ui.mandatory_field_missing")})</span>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                {filtersWrapperOpened === "DRIVE" ? <FiChevronUp /> : <FiChevronDown />}
              </div>
            </div>
          )}

          {motorTab && (
            <div
              id="select-tab-filters-motor"
              onClick={() => handleClickTab("MOTOR")}
              className={`flex-1 max-w-[33%] flex drop-shadow border-[1px] border-solid border-gray-50 border-l-4 border-l-primary px-2 py-1 select-none cursor-pointer ${
                filtersWrapperOpened && filtersWrapperOpened !== "MOTOR"
                  ? "bg-gray-200 text-gray-500"
                  : "bg-white border-b-0"
              } ${isMobile && filtersWrapperOpened && filtersWrapperOpened !== "MOTOR" && "hidden"}`}
            >
              <div className="flex-1 flex flex-col">
                <span className="text-xs font-bold uppercase text-left">{t("msizer.ui.motor")}</span>
                <div className="flex text-xxs space-x-1">
                  <span>{getFiltersAppliedText("Motor")} </span>
                  {!mandatoryFiltersFilled.Motor && (
                    <span className="text-red-500">({t("msizer.ui.mandatory_field_missing")})</span>
                  )}
                </div>
              </div>
              <div className="flex items-center uppercase">
                {filtersWrapperOpened === "MOTOR" ? <FiChevronUp /> : <FiChevronDown />}
              </div>
            </div>
          )}

          {gearboxTab && (
            <div
              id="select-tab-filters-gearbox"
              className={`flex-1 max-w-[33%] flex drop-shadow border-[1px] border-solid border-gray-50 border-l-4 px-2 py-1 select-none cursor-pointer ${
                filtersWrapperOpened && filtersWrapperOpened !== "GEARBOX"
                  ? "bg-gray-200 text-gray-500"
                  : "bg-white border-b-0"
              }
              ${!withGearbox ? "border-l-gray-400" : "border-l-primary"} ${
                isMobile && filtersWrapperOpened && filtersWrapperOpened !== "GEARBOX" && "hidden"
              }`}
            >
              <div
                className="flex-1 flex"
                onClick={() => {
                  if (withGearbox || isIntegratedDrivesConfiguration) {
                    handleClickTab("GEARBOX");
                  }
                }}
              >
                <div className="flex-1 flex flex-col">
                  <span className={`text-xs font-bold uppercase text-left ${!withGearbox && "text-gray-400"}`}>
                    {t("msizer.ui.gearbox")}
                  </span>

                  {!withGearbox && (
                    <span className=" text-xxs text-gray-500 text-left">
                      {t("msizer.ui.filters.motor_without_gearbox")}
                    </span>
                  )}
                  {withGearbox && (
                    <div className="flex text-xxs space-x-1">
                      <span>{getFiltersAppliedText("Gearbox")} </span>
                      {!mandatoryFiltersFilled.Gearbox && (
                        <span className="text-red-500">({t("msizer.ui.mandatory_field_missing")})</span>
                      )}
                    </div>
                  )}
                </div>
                {withGearbox && (
                  <div className="flex items-center">
                    {filtersWrapperOpened === "GEARBOX" ? <FiChevronUp /> : <FiChevronDown />}
                  </div>
                )}
              </div>
              {(filtersWrapperOpened !== "GEARBOX" || isIntegratedDrivesConfiguration) && (
                <div className="flex mx-1">
                  <MotorFilters
                    filters={filters}
                    filterToDisplay="gearboxToggleMinimal"
                    onClick={(e) => {
                      if (withGearbox) handleClickTab("GEARBOX");
                    }}
                    axisId={axisId}
                    refetchBundles={refetchBundles}
                    updateMotorFilters={handleGearboxFiltersUpdate}
                    isLoading={isLoadingSyncFilters || isFetchingSyncFilters}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        {filtersWrapperOpened && (
          <div className="h-0">
            <div className="filtersWrapper border-[1px] border-t-0 border-gray-200 p-2 flex flex-col space-y-2 relative select-none bg-white drop-shadow-lg z-20 border-b-4 border-b-primary">
              {filtersWrapperOpened === "MOTOR" && (
                <MotorFilters
                  filters={filters}
                  closeTab={() => dispatch(setFiltersWrapperOpened(null))}
                  axisId={axisId}
                  data-testid="motor-filters"
                  refetchBundles={refetchBundles}
                  updateMotorFilters={handleMotorFiltersUpdate}
                  isLoading={isLoadingSyncFilters || isFetchingSyncFilters}
                />
              )}
              {filtersWrapperOpened === "DRIVE" && (
                <DriveFilters
                  filters={filters}
                  closeTab={() => dispatch(setFiltersWrapperOpened(null))}
                  data-testid="drive-filters"
                  refetchBundles={refetchBundles}
                  updateDriveFilters={handleDriveFiltersUpdate}
                  isLoading={isLoadingSyncFilters || isFetchingSyncFilters}
                />
              )}
              {filtersWrapperOpened === "GEARBOX" && (
                <GearboxFilters
                  filters={filters}
                  closeTab={() => dispatch(setFiltersWrapperOpened(null))}
                  axisId={axisId}
                  data-testid="gearbox-filters"
                  refetchBundles={refetchBundles}
                  updateGearboxFilters={handleGearboxFiltersUpdate}
                  isLoading={isLoadingSyncFilters || isFetchingSyncFilters}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// define props types
FiltersWrapper.propTypes = {
  filters: PropTypes.object.isRequired,
  motorTab: PropTypes.bool,
  driveTab: PropTypes.bool,
  gearboxTab: PropTypes.bool
};

FiltersWrapper.defaultProps = {
  filters: {},
  motorTab: true,
  driveTab: true,
  gearboxTab: true
};

export default FiltersWrapper;
